module.exports = __webpack_public_path__ + "img/login-sk.19e5f548.png";